import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  Edit,
  EditProps,
  ReferenceInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";
import { StoredImage } from "../../../types";

const FormsEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="formImage"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="cover.formImage"
          format={(value: StoredImage) => {
            if (!value) return [];
            if (typeof value === "string")
              return [
                {
                  src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value}`,
                },
              ];
            return value;
          }}
        />
        <TextInput fullWidth source="cover.formVideo" label="forms.video" />

        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="formTitle" label="forms.title" />

          <TextInput fullWidth source="formSubtitle" label="forms.subtitle" />

          <RichTextInput
            toolbar={
              <RichTextInputToolbar>
                <LevelSelect />
                <FormatButtons />
                <ListButtons />
                <LinkButtons />
                <QuoteButtons />
                <ClearButtons />
              </RichTextInputToolbar>
            }
            fullWidth
            source="formDescription"
            label="forms.description"
          />

          <TextInput fullWidth source="formArticle" label="forms.article" />

          <ArrayInput source="extraButtons" label="forms.extraButtons">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="title" label="forms.buttonTitle" />
              <ReferenceInput source="link" reference="services">
                <AutocompleteInput
                  fullWidth
                  label={"forms.buttonLink"}
                  optionText={`serviceName.${locale}`}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>

          <ArrayInput source="prices" label="services.prices">
            <SimpleFormIterator fullWidth>
              <TextInput
                fullWidth
                source="categoryTitle"
                label="services.categoryTitle"
              />
              <ArrayInput source="priceList" label="services.priceList">
                <SimpleFormIterator fullWidth>
                  <TextInput fullWidth source="name" label="services.name" />
                  <TextInput fullWidth source="price" label="services.price" />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  );
};

export default FormsEdit;
